import React, { useState } from 'react';

import { Dialog, DialogContent, useTheme } from '@material-ui/core';
import { BsPatchCheckFill, BsExclamationCircleFill } from 'react-icons/bs';

import API from 'utils/api';
import { useDialog, useSingleton, useSources } from 'hooks';
import { DialogActions, DialogTitle, Progress } from 'components';

import styles from './PublishResultsDialog.module.scss';

const PublishResultsDialog = ({ id, open, onClose }) => {
  const [{ status }, setState] = useState({});

  const theme = useTheme();
  const sources = useSources();
  const singleton = useSingleton();

  const { isOpening } = useDialog(open, {
    onOpen: () => setState({ status: 'confirm' }),
    onClose: () => sources.cancelAll(),
  });

  if (isOpening || !status) {
    return null;
  }

  const publish = () =>
    singleton(async () => {
      setState({ status: 'loading' });

      const { error } = await API.publishResults(id, sources);
      setState({ status: error ? 'error' : 'success' });
    });

  return (
    <Dialog open={open} classes={{ paper: styles.dialog }}>
      <DialogTitle>Publish Results</DialogTitle>

      <div
        className={styles.wrapper}
        style={status === 'loading' ? { visibility: 'hidden' } : undefined}
      >
        <DialogContent className={styles.content}>
          {status === 'confirm' ? (
            <>
              <p>
                This will send a message to all users participating in the draw with the
                winning ticket codes.
              </p>
              <p>Do you want to proceed?</p>
            </>
          ) : status === 'success' ? (
            <div className={styles.center}>
              <BsPatchCheckFill style={{ color: theme.palette.success.main }} />
              <p>Results published successfully!</p>
            </div>
          ) : (
            <div className={styles.center}>
              <BsExclamationCircleFill style={{ color: theme.palette.error.main }} />
              <p>Something went wrong</p>
            </div>
          )}
        </DialogContent>

        <DialogActions
          actions={
            status === 'confirm'
              ? [
                  { label: 'no, cancel', onClick: onClose },
                  { label: 'yes, publish', onClick: publish, variant: 'contained' },
                ]
              : [{ label: 'close', onClick: onClose, variant: 'contained' }]
          }
        />
      </div>

      {status === 'loading' ? (
        <div className={styles.loader}>
          <Progress />
        </div>
      ) : null}
    </Dialog>
  );
};

export default PublishResultsDialog;
